import React, { Component } from "react";
import { observer } from "mobx-react";
import {
    fn_setCsTypeKey, fn_getCsTypeKey,
    fn_setCsType, fn_getCsType, fn_vocsRequierd,
    fn_vocsDetail, fn_setAgreeFlag, fn_getAgreeFlag
} from "function/FnBodyDetail";
import { checkByte, onlyNumber } from "utils/Utils";

@observer
class VoVsView extends Component {
    constructor(props) {
        super(props);
        this.inputFocus = React.createRef();
    }

    render() {

        const { rootStore } = this.props;
        const viewStore = rootStore.viewStore;
        const layerStore = rootStore.layerStore;
        const cs = viewStore.getVocsDetail;

        return (
            <div className={"layer_comm layer_common_type " + (layerStore.getLayerCsView ? ' layer_open' : '')}>
                <div className="bg"></div>
                <div className="layer_content cs">
                    <div className="article_common_type">
                        <div className="section_tit_comm_cs">
                            <h1>문의접수</h1>
                        </div>
                        <div className="cs_container">
                            <div className="left">
                                <h2>간편한 셀프 해결법</h2>
                                <p className="text">문의 접수하시기 전에 확인해주세요</p>

                                <p className="tit"><span className="ico" />배달앱 주문서가 주방에 안 나와요</p>
                                <div className="tit_box">
                                    <li>배달매니저에 해당 주문이 조회되지 않았다면<br/>
                                        <strong>PC 재부팅 후 주문전표(고객용)를 재출력</strong>해보세요<br/>
                                        증상 지속시, 배달매니저에 문의 남겨주세요
                                    </li>
                                    <li><strong>홀 주문서도 미출력시, PC 재부팅 후 재시도</strong> 해주세요<br/>
                                        증상 지속시, 관리대리점에 문의해주세요
                                    </li>
                                </div>

                                <p className="tit"><span className="ico_trans" />배달앱 매출이 누락됐어요</p>
                                <div className="tit_box">
                                    <li><strong>PC를 재부팅</strong>하고 배달앱 프로그램에서 <strong>주문전표</strong><br/>
                                        <strong>(고객용)을 재출력</strong>해 주세요<br/>
                                    </li>
                                    <li>주문전표(고객용)을 재출력할 수 없다면 <strong>[매출요약{' >'}<br/>
                                    매출등록]에서 수기로 매출을 등록</strong>하세요
                                    </li>
                                </div>

                                <p className="tit"><span className="ico"/>배달매니저에서 라이더 호출이 안돼요</p>
                                <div className="tit_box">
                                     <li><strong>배달대행 업체를 변경</strong>했거나 대행사 프로그램을 <strong>재설치</strong><br/>
                                        했다면<strong> 재연동 해주세요</strong> (설정{' > '}배달대행사 관리)
                                    </li>
                                    <li><strong>사업자번호가 변경</strong>된 경우, 변경된 사업자번호와 함께<br/>
                                    <strong>문의를 남겨주세요</strong>
                                    </li>
                                </div>

                                <p className="tit"><span className="ico_trans"/>주문이 완료처리가 안돼 포스 마감이 안돼요</p>
                                <div className="tit_box">
                                     <li><strong>익일 개점전 연락 가능 시간을 문의접수로 남겨주세요</strong><br/>
                                        주문내역 확인 후 오픈 전에 연락드리겠습니다
                                    </li>
                                </div>
                              
                            </div>
                         
                            <div className="btnsCol">
                                <button type="button" className="btn_up disabled" ><span></span></button>
                                <button type="button" className="btn_down disabled"><span></span></button>
                            </div>

                            <div className="section_textarea cs">
                                <h2>문의유형 <strong> *</strong></h2>
                                <div className="select">
                                    <button type="button" className="num type"
                                        onClick={event => fn_setCsType(rootStore, !fn_getCsType(rootStore))}
                                    ><span>{fn_getCsTypeKey(rootStore).val}</span></button>
                                    <ul className={"layer " + (fn_getCsType(rootStore) === true ? "open" : "")}>
                                        <li>
                                            <button type="button"
                                                onClick={event => {
                                                    fn_setCsTypeKey(rootStore, '405', '주문 접수 관련');
                                                    rootStore.viewStore.setLayerVocsTypeView(false)}
                                                }
                                            >주문 접수 관련</button>
                                        </li>
                                        <li>
                                            <button type="button"
                                                onClick={event => {
                                                    fn_setCsTypeKey(rootStore, '410', '배달 대행 관련')
                                                    rootStore.viewStore.setLayerVocsTypeView(false)}
                                                }
                                            >배달 대행 관련</button>
                                        </li>
                                        <li>
                                            <button type="button"
                                                onClick={event => {
                                                    fn_setCsTypeKey(rootStore, '406', '출력 관련')
                                                    rootStore.viewStore.setLayerVocsTypeView(false)}
                                                }
                                            >출력 관련</button>
                                        </li>
                                        <li>
                                            <button type="button"
                                                onClick={event => {
                                                    fn_setCsTypeKey(rootStore, '411', '포스 마감')
                                                    rootStore.viewStore.setLayerVocsTypeView(false)}
                                                }
                                            >포스 마감</button>
                                        </li>
                                        <li>
                                            <button type="button"
                                                onClick={event => {
                                                    fn_setCsTypeKey(rootStore, '411', '기타')
                                                    rootStore.viewStore.setLayerVocsTypeView(false)}
                                                }
                                            >기타</button>
                                        </li>
                                    </ul>
                                </div>
                                <h2>문의내용 <strong> *</strong></h2>
                                <textarea ref={this.inputFocus} value={cs.vocMsg ? cs.vocMsg : ''} placeholder="장애 접수시에는 신속한 대응을 위해 
                                발생증상/지속여부/주문정보 등을 작성해주세요" id="textarea" maxLength={500}
                                onChange={event => fn_vocsDetail(rootStore, event.target.value, "vocMsg")}
                                ></textarea>
                                <h2>연락처 <strong> *</strong></h2>
                                <input id="phone" type="text" className="num" placeholder="숫자만 입력하세요"
                                    value={cs.hpTelNo ? onlyNumber(cs.hpTelNo) : ''} onChange={event => fn_vocsDetail(rootStore, event.target.value, "hpTelNo")}
                                />
                                <div className="info">
                                    <p>• 간편한 셀프 해결법으로 신속하게 대응해보세요.</p>
                                    <p>• 접수된 문의는 확인 후 연락드리겠습니다.</p>
                                </div>
                                <div className="item">
                                    <label>
                                        <input type="checkbox" name="item2" checked={rootStore.viewStore.getVocsAgreeDetail ? true : false}
                                        onChange={() => fn_setAgreeFlag(rootStore, !fn_getAgreeFlag(rootStore))} />
                                        <span className="ico"></span>
                                        <span className="cont"
                                            onClick={event => {
                                                event.preventDefault();
                                                layerStore.setLayerCsAgreeView(true)
                                            }}
                                        ><strong>개인정보 수집 및 이용 안내</strong>에 동의합니다</span>
                                    </label>
                                </div>
                                <button type="button" className="sendBtn"
                                    onClick={event => { fn_vocsRequierd(rootStore) }}
                                >문의접수</button>
                                <p className="val">{rootStore.viewStore.getVocsDetail.val}</p>
                            </div>
                        </div>
                        <div className="btn_close btn_close_comm_white">
                            <button
                                onClick={event => { layerStore.setLayerCsView(false); viewStore.setVocsInitDetail(); viewStore.setLayerVocsTypeView(false) }}
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default VoVsView;